module.exports = __webpack_public_path__ + "img/american-credit-home-slide-12.a393b7e.webp";